import { forwardRef, type CSSProperties, type MouseEvent, type ReactNode } from 'react';

import { cn } from '@/shared/lib/utils';

interface PopoverSurfaceProps {
  /** Computed fixed positioning (from `usePopoverPosition`). */
  positionStyle: CSSProperties;
  className?: string;
  children: ReactNode;
  onMouseDown?: (event: MouseEvent<HTMLDivElement>) => void;
  'data-testid'?: string;
}

/**
 * The floating popover surface for the date/time boxes. Portalled to `document.body` by the parent
 * (so it sits above PhoenixDesktop windows); positioning comes in as `positionStyle`.
 */
export const PopoverSurface = forwardRef<HTMLDivElement, PopoverSurfaceProps>(
  function PopoverSurface(
    { positionStyle, className, children, onMouseDown, 'data-testid': testId },
    ref
  ) {
    return (
      <div
        ref={ref}
        style={positionStyle}
        data-testid={testId}
        onMouseDown={onMouseDown}
        className={cn(
          'phx-root bg-phx-surface border-phx-border-2 shadow-phx-lg rounded-phx-md border p-2.5',
          className
        )}
      >
        {children}
      </div>
    );
  }
);
